(function ($) {
  /**
   * initializeBlock
   *
   * Adds custom JavaScript to the block HTML.
   *
   */

  const initializeBlock = function () {
    $(".steps-swiper").each(function () {
      let stepsSwiper;
      const el = $(this)[0];
      const options = {
        loop: false,
        autoHeight: false,
        slidesPerView: 1.3,
        spaceBetween: 20,
        watchOverflow: true,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
        },
        on: {
          transitionStart: function () {
            $("html, body").addClass("overflow-hidden");
          },
          transitionEnd: function () {
            $("html, body").removeClass("overflow-hidden");
          },
        },
      };

      el.addEventListener("touchmove", (e) => e.preventDefault(), {
        passive: false,
      });

      if ($(window).width() < 768 && !stepsSwiper) {
        stepsSwiper = new Swiper(el, options);
      } else if ($(window).width() >= 768 && stepsSwiper) {
        stepsSwiper.destroy();
        stepsSwiper = undefined;
      }

      $(window).on("resize", function () {
        if ($(window).width() < 768 && !stepsSwiper) {
          stepsSwiper = new Swiper(el, options);
        } else if ($(window).width() >= 768 && stepsSwiper) {
          stepsSwiper.destroy();
          stepsSwiper = undefined;
        }
      });
    });
  };

  // Initialize each block on page load (front end).
  $(function () {
    initializeBlock($(this));
  });

  // // Initialize dynamic block preview (editor).
  // if( window.acf ) {
  //     window.acf.addAction('render_block_preview/type=program', initializeBlock)
  // }
})(jQuery);
